import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
export default class Timeline {
    constructor() {
        this.sections = document.querySelectorAll('.timeline');
        
        this.ready();
    }

    ready() {

        this.sections.forEach(sections => {
            const sectionSliders = sections.querySelectorAll('.swiper--timeline')
            sectionSliders.forEach(slider => {
                const swiper = new Swiper(slider, {
                    modules: [Pagination, EffectFade],
                    speed: 500,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    grabCursor: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    allowTouchMove: true,
                    pagination: {
                        el: sections.querySelector(".swiper-pagination-custom"),
                        clickable: true,
                        renderBullet: (index, className) => {
                            const getNameBullet = slider.querySelectorAll('.swiper-slide-year')[index].dataset.ano
                            return '<button class="' + className + '">' + (getNameBullet) + "<span></span></button>";
                        },
                      },
                });

                const slidersYearsIntern = slider.querySelectorAll('.swiper--timeline-year')
                slidersYearsIntern.forEach(sliderYears => {
                    const swiperIntern = new Swiper(sliderYears, {
                        modules: [Pagination, Navigation],
                        grabCursor: true,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        allowTouchMove: true,
                        navigation: {
                            nextEl: sliderYears.querySelector(".slider-button-next--timeline-year"),
                            prevEl: sliderYears.querySelector(".slider-button-prev--timeline-year"),
                        },
                        pagination: {
                            el: sliderYears.querySelector(".swiper-pagination-nav--timeline-year"),
                            type: 'fraction',
                        },
                    }); 
                })

            })

        })

    }
    
    templateThumbs(titulo) {
        const template = `
            <li class="swiper-slide">
                <button class="group text-">${titulo}</button>
            </li>
        `;
        return template
    }
}

if (document.querySelector('.timeline')) {
    new Timeline();
}